import React from 'react';

import { useForwardRef } from '../hooks/useForwardRef';
import { cnText } from './Text.cn';
import { useOverflow } from './Text.hooks/useOverflow';
import type { TextProps } from './Text.types';
import { TextWrapper } from './Wrapper';

import './Text.css';

export function Text(props: TextProps) {
    const {
        className,
        children,
        color,
        as: ElementType = 'p',
        refOnText,
        align,
        maxVisibleLines,
        weight,
        style,
        overflowTooltipProps,
        typography,
        hasTooltip: propHasTooltip,
        isThinking,
        ...restProps
    } = props;

    const elementRef = useForwardRef({ forwardedRef: refOnText });

    const { hasTooltip, tooltipProps } = useOverflow({
        maxVisibleLines,
        overflowTooltipProps,
        elementRef,
        children,
    });

    return (
        <TextWrapper hasTooltip={propHasTooltip ?? hasTooltip} tooltipProps={tooltipProps}>
            <ElementType
                {...restProps}
                ref={elementRef}
                style={{ ...style, '--text-max-visible-lines': maxVisibleLines }}
                className={cnText(
                    {
                        align,
                        color,
                        weight,
                        typography,
                        hideOverflow: maxVisibleLines === 1,
                        hideLines: Number(maxVisibleLines) > 1,
                        isThinking,
                    },
                    [className],
                )}
            >
                {children}
            </ElementType>
        </TextWrapper>
    );
}
